"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.axiosApi = void 0;
exports.del = del;
exports.get = get;
exports.patch = patch;
exports.post = post;
exports.put = put;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//apply base url for axios
const axiosApi = exports.axiosApi = _axios.default.create({
  validateStatus: status => status < 500
});
axiosApi.interceptors.response.use(response => response, error => Promise.reject(error));
async function get(url) {
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return axiosApi.get(url, {
    ...config
  });
}
async function post(url, data) {
  let config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return axiosApi.post(url, {
    ...data
  }, {
    ...config
  });
}
async function put(url, data) {
  let config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return axiosApi.put(url, {
    ...data
  }, {
    ...config
  });
}
async function patch(url, data) {
  let config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return axiosApi.patch(url, {
    ...data
  }, {
    ...config
  });
}
async function del(url) {
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return axiosApi.delete(url, {
    ...config
  });
}